<template>
    <section class="padding-vertical-content mb-3 mb-lg-4" id="paso-2">
        <div class="container">
            <div class="row">
                <div class="col-12">
                    <div class="mb-4 h3 text-uppercase">
                        Completa la siguiente información
                    </div>
                    <div class="padding-content white-content mb-2">
                        <div class="mb-4 h4 text-uppercase">
                            Datos del responsable 1
                        </div>
                        <ValidationObserver tag="form" ref="observer" @submit.prevent="submit()">
                            <div class="row">
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="nombre">{{ $t("formularios.nombre") + ' *' }}</label>
                                        <ValidationProvider name="nombre_responsable" rules="required" v-slot="{ errors }">
                                            <input id="nombre_responsable" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.nombre')" v-model="base.nombre_responsable" />
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="apellidos_responsable">{{ $t("formularios.apellidos") + ' *' }}</label>
                                        <ValidationProvider name="apellidos_responsable" rules="required" v-slot="{ errors }">
                                            <input id="apellidos_responsable" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.apellidos')" v-model="base.apellidos_responsable"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="dni_responsable">{{ $t("formularios.dni") + ' *' }}</label>
                                        <ValidationProvider name="dni_responsable" rules="required" v-slot="{ errors }">
                                            <input id="dni_responsable" type="text" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.dni')" v-model="base.dni_responsable"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="telefono_responsable">{{ $t("formularios.telefono") + ' *' }}</label>
                                        <ValidationProvider name="telefono_responsable" rules="required" v-slot="{ errors }">
                                            <input id="telefono_responsable" type="tel" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.telefono')" v-model="base.telefono_responsable"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="email_responsable">{{ $t("formularios.email") + ' *' }}</label>
                                        <ValidationProvider name="email_responsable" rules="required" v-slot="{ errors }">
                                            <input id="email_responsable" type="email" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" :placeholder="$t('formularios.email')" v-model="base.email_responsable"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12">
                                    <div class="mb-4 h4 text-uppercase">
                                        Datos del responsable 2
                                    </div>    
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="nombre_responsable_2">{{ $t("formularios.nombre") }}</label>
                                        <ValidationProvider name="nombre_responsable_2">
                                            <input id="nombre_responsable_2" type="text" class="form-control" :placeholder="$t('formularios.nombre')" v-model="base.nombre_responsable_2"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="apellidos_responsable_2">{{ $t("formularios.apellidos") }}</label>
                                        <ValidationProvider name="apellidos_responsable_2">
                                            <input id="apellidos_responsable_2" type="text" class="form-control" :placeholder="$t('formularios.apellidos')" v-model="base.apellidos_responsable_2"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="dni_responsable_2">{{ $t("formularios.dni") }}</label>
                                        <ValidationProvider name="dni_responsable_2">
                                            <input id="dni_responsable_2" type="text" class="form-control" :placeholder="$t('formularios.dni')" v-model="base.dni_responsable_2"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="telefono_responsable_2">{{ $t("formularios.telefono") }}</label>
                                        <ValidationProvider name="telefono_responsable_2">
                                            <input id="telefono_responsable_2" type="tel" class="form-control" :placeholder="$t('formularios.telefono')" v-model="base.telefono_responsable_2"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <div class="col-12 col-md-6 col-lg-4 mt-2">
                                    <div class="form-group">
                                        <label for="email_responsable_2">{{ $t("formularios.email") }}</label>
                                        <ValidationProvider name="email_responsable_2">
                                            <input id="email_responsable_2" type="email" class="form-control" :placeholder="$t('formularios.email')" v-model="base.email_responsable_2"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                                <br />
                                <div class="col-12 col-md-12 col-lg-12 mt-2">
                                    <div class="form-group">
                                        <label for="observaciones">Observaciones *</label>
                                        <ValidationProvider name="observaciones" v-slot="{ errors }">
                                            <input id="observaciones" type="textarea" :class="'form-control ' + (errors[0] ? 'is-invalid' : '')" placeholder="Observaciones" v-model="base.observaciones"/>
                                        </ValidationProvider>
                                    </div>
                                </div>
                            </div>
                            <div class="mt-4">  
                                <button type="submit" name="button" class="button effect-button large-button" id="terminar-paso-2">
                                    <span>CONTINUAR</span>
                                </button>
                            </div> 
                        </ValidationObserver>
                    </div>
                </div>
            </div>
        </div>
    </section>  
</template>

<script>
    export default {
        props: ["base"],
        data() {
            return {};
        },
        methods: {
            terminar() {
                this.$emit('terminado');
            },
            async submit() {
                const isValid = await this.$refs.observer.validate();
                if(isValid) {
                    this.terminar();
                }
            }
        }
    };
</script>